import type {
  // PeopleJsonldReadCollectionCluster,
  // PeopleJsonldReadCollectionCollaborator,
  PeopleJsonldReadCollectionProject,
  PeopleJsonldReadItemClusterItem,
  PeopleJsonldReadItemCollaboratorItem,
  PeopleJsonldReadItemPeople,
  PeopleJsonldReadItemProject,
} from "@/networking/api"
import type { LocalRefLabel } from "@/utils/i18n/t11n"

export type PeopleJsonld =
  // | PeopleJsonldReadCollectionCollaborator
  // | PeopleJsonldReadCollectionCluster
  | PeopleJsonldReadItemPeople
  | PeopleJsonldReadCollectionProject
  | PeopleJsonldReadItemProject
  | PeopleJsonldReadItemCollaboratorItem
  | PeopleJsonldReadItemClusterItem

export type RelatedPeople = PeopleJsonld & {
  role?: LocalRefLabel | null
}

/**
export type PeopleRelation =
  | ProjectPeopleJsonldReadCollectionProject
  | ProjectPeopleJsonldReadItemProject
  | RelPeopleCollaboratorJsonldReadCollectionCollaborator
  | RelPeopleCollaboratorJsonldReadItemCollaboratorItem
  | RelClusterPeopleJsonldReadCollectionCluster
  | RelClusterPeopleJsonldReadItemClusterItem
*/

export const PEOPLE_TITLE_GROUP = "people:title:"
export const PEOPLE_CONTACT_METHOD_GROUP = "people:contact_method:"
export const PEOPLE_MARITAL_STATUS_GROUP = "marital:status:"
export const PEOPLE_MARITAL_CONTRACT_STATUS_GROUP = "marital:contract_status:"

export const PEOPLES_SORT_COLUMN_DEFAULT = "lastname"
export const PEOPLES_SORT_ORDER_DEFAULT = "asc"

export const PeopleStatus = {
  ACTIVE: "active",
  ARCHIVE: "archive",
  ERROR: "error",
} as const
export type PeopleStatus = (typeof PeopleStatus)[keyof typeof PeopleStatus]
